import { AuthenticationService } from './../api/authentication.service';
import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanLoad {

  constructor(private authService: AuthenticationService, private router: Router) { }

  canActivate(): boolean {

    if (this.authService.isAuthenticated.value) {
      console.log("CanActivate succesfull");
      return true;
    } else {
      console.log("CanActivate failed");
      return false;
    }
  }

  canLoad(): Observable<boolean> {  
    console.log('AuthGuard: canLoad ' + this.authService.isAuthenticated.value);

    return this.authService.isAuthenticated.pipe(
      filter(val => val !== null), // Filter out initial Behaviour subject value
      take(1), // Otherwise the Observable doesn't complete!
      map(isAuthenticated => {
        if (isAuthenticated) {          
          return true;
        } else {          
          this.router.navigateByUrl('/login')
          return false;
        }
      })
    );
  }
}
